<template>
	<div>
		<div class="d-flex">
			<div
				class="mr-3 product-preview-picture-40 flex-shrink-0"
				v-if="usePreviewPicture"
			>
				<div data-html="true" data-toggle="popover" ref="preview" v-if="preview">
					<img :src="previewThumbnail" class="img-fluid">
				</div>
				<div v-else>
					<img :src="images.noimage" class="img-fluid">
				</div>
			</div>
			<div class="d-block">
				<h2 class="fs-sm mb-0 mt-1 mr-2 font-weight-normal">
					<a v-if="row.url" :href="row.url" v-html="name"></a>
					<span v-else v-html="name"></span>
				</h2>

				<div v-if="vendorCode || view !== 'sku' && brand" class="text-muted">
					<span v-if="vendorCode">{{ vendorCode }}</span>
					<template  v-if="view !== 'sku' && brand">
						<span v-if="vendorCode && view !== 'sku' && brand" class="kt-badge kt-badge--dot kt-badge--sm kt-badge--metal"></span>
						<span v-if="view !== 'sku' && brand" v-html="brand"></span>
					</template>
				</div>

				<div class="mt-2" v-if="view !== 'sku' && labels.length">
					<span
						class="badge mr-1 mb-1"
						:class="`label-${(label.code || '').toLowerCase()} badge--unified-${label.modifier}`"
						v-for="label in labels" :key="label.code"
						v-html="label.name"
					></span>
				</div>

			</div>
		</div>
	</div>
</template>

<script>

import FieldMixin from './FieldMixin.js';
import { getProductName, getVendorCode } from '../utils';

export default {

	mixins: [FieldMixin],

	props: {
		view: {
			type: String,
			default: 'default'
		},
		useImageFromGroupingItem: {
			type: Boolean,
			default: true
		}
	},

	computed: {

		name()
		{
			return getProductName(this.row, this.product);
		},

		vendorCode()
		{
			const vendorCode = getVendorCode(this.row, this.product);
			return vendorCode ? BX.message('RS.B2BPORTAL.TABLE.COLS.ARTICLE').replace('#NUMBER#', vendorCode) : false;
		},

		brand()
		{
			return this.row.brand !== '' ? this.row.brand : false;
		},

		hasSku()
		{
			return Object.keys(this.row.sku).length > 0;
		},

		preview()
		{
			return (this.product.preview || {}).SRC || (this.useImageFromGroupingItem ? (this.row.preview || {}).SRC : '');
		},

		previewThumbnail()
		{
			return this.useImageFromGroupingItem ?
				((this.product.previewThumbnail || this.row.previewThumbnail || {}).src) || this.preview :
				this.product.previewThumbnail || this.preview;
		},

		usePreviewPicture()
		{
			return this.$store.getters[`${this.$root.$namespace}/isShowPreview`];
		},

		labels()
		{
			return this.row.labels;
		},

		images()
		{
			return ((this.$root.params || {}).imagesPath) || {};
		}

	},

	mounted()
	{
		this.initPreviewPopovers();
	},

	methods: {
		initPreviewPopovers()
		{
			if (this.usePreviewPicture)
			{
				$(this.$refs.preview).popover({
					trigger: 'hover',
					placement: 'right',
					boundary: 'window',
					html: true,
					content: () =>  `<img class="img-fluid" src="${this.preview}" />`,
					title: '',
				});

			}
		}
	},

	watch: {
		preview()
		{
			this.$nextTick(() => {
				this.initPreviewPopovers();
			});
		}
	}
}
</script>

<style scoped>
.product-preview-picture-40 { text-align: center; }
.product-preview-picture-40 { width: 2.5rem; }
.product-preview-picture-40 .img-fluid { max-height: 2.5rem; }
</style>